import React, {Component} from 'react';
/*
* Authentication
*/
import Alt from 'alt';
import history from '../../history';
import axios from 'axios';
import AuthActions from '../../actions/AuthActions';


class Logout extends React.Component {

    constructor(props){
        super(props);
        let context = this;
        
        AuthActions.logout();
        context.redirectToLogin();
    }
    
    render(){    
        return <div>LOGOUT</div>
    }
    
    redirectToLogin(){
        //history.replace("#/login");
        this.props.history.push('/login');
    }
}

export default Logout;


// WEBPACK FOOTER //
// ./src/components/Logout/Logout.js